import { SR_API_ACTION_UTILITY_ACTIVATION_GET_LIST } from 'api/utilityActionTypes';

export default async function getCountByPartnerId(
  { state, utilityApiClient },
  { utilityPartnerId },
) {
  const statePath = ['utilityActivations', 'countByPartnerId', utilityPartnerId];

  await utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_ACTIVATION_GET_LIST,
    state: state,
    payload: {
      utilityPartnerId,
      countOnly: true,
    },
    onSuccess(utilityActivations) {
      if (utilityActivations) {
        state.set(statePath, utilityActivations[0]?.count || 0);
        return utilityActivations;
      }
    },
  });
}
